











































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IDocumentTileModel } from '@/models/common';
const BLOB_URL = 'https://sulekhaportal.blob.core.windows.net/docs/';
@Component
export default class DocumentTile extends Vue {
    @Prop() public data!: IDocumentTileModel;

    get imageUrl() {
        return BLOB_URL + this.data.img;
    }
    public download() {
        window.open(BLOB_URL + this.data.link);
    }
}
